/* Kiariva theme — storefront behaviour (no dependencies).
   Uses Shopify's Ajax Cart API, Section Rendering API, Predictive Search API
   and Product Recommendations API. */
(function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
    var WISH_KEY = 'mirelle:wishlist';
  var RECENT_KEY = 'mirelle:recent';

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key));
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 2600);
  }
  T.toast = toast;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    if (!format && T.rupee) {
      var whole = Math.floor(cents / 100), paise = cents % 100;
      var str = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '₹' + str + (paise ? '.' + (paise < 10 ? '0' : '') + paise : '');
    }
    format = format || T.moneyFormat || '₹{{amount}}';
    function group(n, decimals, thousands, dec) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', val;
    switch (key) {
      case 'amount_no_decimals': val = group(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = group(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = group(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = group(cents, 2, "'", '.'); break;
      default: val = group(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  T.formatMoney = formatMoney;

  /* ---------- drawers (menu, cart, filters) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var f = d.querySelector('[data-autofocus], button, a, input, select');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open') && !$('.search-modal.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  T.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    var sm = $('.search-modal.is-open'); if (sm) closeSearch();
  });
  // keep keyboard focus inside an open drawer
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = $('.drawer.is-open .drawer__panel') || $('.search-modal.is-open'); if (!d) return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', d)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- time-limited content: hide when its fixed end time has passed ---------- */
  function nowSec() { return Math.floor(Date.now() / 1000); }
  $$('[data-ends]').forEach(function (el) {
    var end = parseInt(el.getAttribute('data-ends'), 10);
    if (end && nowSec() >= end && !el.hasAttribute('data-countdown-wrap')) el.remove();
  });

  /* ---------- announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length && items.every(function (it) { return it.hidden; })) items[0].hidden = false;
    if (items.length < 2) return;
    var i = 0, timer;
    function show(n) { items[i].hidden = true; i = (n + items.length) % items.length; items[i].hidden = false; }
    function start() { if (bar.dataset.autoplay === 'true') timer = setInterval(function () { show(i + 1); }, 5000); }
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-prev]')) { clearInterval(timer); show(i - 1); }
      if (e.target.closest('[data-next]')) { clearInterval(timer); show(i + 1); }
    });
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    start();
  });

  /* ---------- cart ---------- */
  function sectionIdsForCart() {
    var ids = ['cart-drawer', 'cart-count'];
    var page = $('[data-cart-page]'); if (page) ids.push(page.dataset.sectionId);
    return ids;
  }
  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = parseHTML(html);
      $$('[data-section-render="' + id + '"]').forEach(function (target) {
        var fresh = doc.querySelector('[data-section-render="' + id + '"]');
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
  function cartFetch(url, body) {
    body.sections = sectionIdsForCart().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        return data;
      });
    });
  }
  function addToCart(items, opts) {
    opts = opts || {};
    return cartFetch(R.cartAdd + '.js', { items: items }).then(function (data) {
      renderCartSections(data.sections);
      if (opts.redirect) { window.location.href = opts.redirect; return data; }
      if (T.cartType === 'page') { window.location.href = R.cart; return data; }
      toast(T.strings.added);
      openDrawer('CartDrawer');
      return data;
    });
  }
  T.addToCart = addToCart;

  function changeLine(line, qty) {
    var wrap = $$('[data-section-render="cart-drawer"], [data-cart-page]');
    wrap.forEach(function (w) { w.classList.add('is-loading'); });
    return cartFetch(R.cartChange + '.js', { line: line, quantity: qty })
      .then(function (data) {
        renderCartSections(data.sections);
        var item = data.items && data.items[line - 1];
        if (qty > 0 && item && item.quantity < qty) toast(T.strings.maxStock || 'Only ' + item.quantity + ' available');
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { wrap.forEach(function (w) { w.classList.remove('is-loading'); }); });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.line, 10), 0); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var box = step.closest('.qty'); var input = box && box.querySelector('input'); if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      if (input.max && v > parseInt(input.max, 10)) v = parseInt(input.max, 10);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', debounce(function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  }, 350));
  // change a cart line to another variant (e.g. a different shade)
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cart-variant]'); if (!sel) return;
    var line = parseInt(sel.dataset.line, 10), qty = parseInt(sel.dataset.quantity, 10) || 1;
    var newId = parseInt(sel.value, 10);
    cartFetch(R.cartChange + '.js', { line: line, quantity: 0 })
      .then(function () { return cartFetch(R.cartAdd + '.js', { items: [{ id: newId, quantity: qty }] }); })
      .then(function (data) { renderCartSections(data.sections); toast(T.strings.updated || 'Cart updated'); })
      .catch(function (err) { toast(err.message); });
  });
  // discount codes through the Ajax Cart API
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]'); if (!form) return;
    e.preventDefault();
    var code = form.querySelector('input').value.trim(); if (!code) return;
    var existing = $$('[data-discount-code]').map(function (el) { return el.dataset.discountCode; })
      .filter(function (c, i, a) { return a.indexOf(c) === i; });
    if (existing.indexOf(code) === -1) existing.push(code);
    cartFetch(R.cartUpdate + '.js', { discount: existing.join(',') }).then(function (data) {
      renderCartSections(data.sections);
      var applied = (data.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      toast(applied && applied.applicable ? 'Code ' + code + ' applied' : 'Code ' + code + ' can’t be used with this cart');
    }).catch(function (err) { toast(err.message); });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-remove]'); if (!btn) return;
    var keep = $$('[data-discount-code]').map(function (el) { return el.dataset.discountCode; })
      .filter(function (c, i, a) { return c !== btn.dataset.discountRemove && a.indexOf(c) === i; });
    cartFetch(R.cartUpdate + '.js', { discount: keep.join(',') }).then(function (data) { renderCartSections(data.sections); });
  });
  // upsell / single-variant quick add buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add-id]'); if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    addToCart([{ id: parseInt(btn.dataset.quickAddId, 10), quantity: 1 }])
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- quick view (multi-variant products) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]'); if (!btn) return;
    e.preventDefault();
    var drawer = document.getElementById('QuickView'); if (!drawer) { window.location.href = btn.dataset.quickView; return; }
    var body = drawer.querySelector('.drawer__body');
    body.innerHTML = '<p class="muted">Loading…</p>';
    openDrawer('QuickView');
    fetch(btn.dataset.quickView + (btn.dataset.quickView.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var content = doc.querySelector('[data-quick-view-content]');
        body.innerHTML = content ? content.innerHTML : '';
        $$('[data-product-form]', body).forEach(initProductForm);
      })
      .catch(function () { window.location.href = btn.dataset.quickView; });
  });

  /* ---------- product form & variant picker ---------- */
  function initProductForm(root) {
    if (root._init) return; root._init = true;
    var dataEl = root.querySelector('[data-product-json]'); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('input[name="id"]');
    var isMain = root.hasAttribute('data-main-product');
    var lowStock = parseInt(root.dataset.lowStock || '0', 10);

    function selectedOptions() {
      return product.options.map(function (name, i) {
        var checked = root.querySelector('[data-option-index="' + i + '"]:checked');
        var select = root.querySelector('select[data-option-index="' + i + '"]');
        return checked ? checked.value : select ? select.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      })[0];
    }
    function markAvailability(opts) {
      product.options.forEach(function (name, i) {
        $$('[data-option-index="' + i + '"]', root).forEach(function (input) {
          var values = input.tagName === 'SELECT' ? $$('option', input) : [input];
          values.forEach(function (el) {
            var test = opts.slice(); test[i] = el.value;
            var ok = product.variants.some(function (v) {
              return v.available && v.options.every(function (o, j) { return o === test[j]; });
            });
            el.classList.toggle('is-unavailable', !ok);
            if (el.tagName === 'OPTION') el.textContent = el.value + (ok ? '' : ' — ' + T.strings.soldOut);
          });
        });
        var label = root.querySelector('[data-option-value-label="' + i + '"]');
        if (label) label.textContent = opts[i] || '';
      });
    }
    function setText(sel, text) { $$(sel, root).forEach(function (el) { el.textContent = text; }); }

    function update(fromUser) {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      var buttons = $$('[data-add-button]', root).concat(isMain ? $$('[data-sticky-add]') : []);
      var buyNow = root.querySelector('[data-buy-now]');
      if (!v) {
        buttons.forEach(function (b) { b.disabled = true; b.textContent = T.strings.unavailable; });
        if (buyNow) buyNow.disabled = true;
        setText('[data-stock]', T.strings.unavailable);
        return;
      }
      idInput.value = v.id;
      // price
      $$('[data-price]', root).forEach(function (p) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        var html = '<span class="price__now">' + formatMoney(v.price) + '</span>';
        if (onSale) {
          var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          html += '<span class="price__compare">' + (T.compareLabel || 'MRP') + ' <s>' + formatMoney(v.compare_at_price) + '</s></span>';
          if (T.showSavePercent && pct > 0) html += '<span class="price__save">' + (T.strings.off || 'PCT% off').replace('PCT', pct) + '</span>';
        }
        p.innerHTML = html;
      });
      // stock (based on real inventory data from Shopify)
      $$('[data-stock]', root).forEach(function (s) {
        s.classList.remove('stock--out', 'stock--low');
        if (!v.available) { s.textContent = T.strings.soldOut; s.classList.add('stock--out'); }
        else if (lowStock > 0 && v.inventory_managed && v.inventory_quantity > 0 && v.inventory_quantity <= lowStock && !v.continue_selling) {
          s.textContent = 'Only ' + v.inventory_quantity + ' left'; s.classList.add('stock--low');
        } else { s.textContent = T.strings.inStock || 'In stock'; }
      });
      buttons.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; });
      if (buyNow) buyNow.disabled = !v.available;
      $$('[data-sticky-variant]').forEach(function (el) { if (isMain) el.textContent = v.title === 'Default Title' ? '' : v.title; });
      // media
      if (v.featured_media_id) {
        var slide = root.querySelector('[data-media-id="' + v.featured_media_id + '"]') || document.querySelector('[data-media-id="' + v.featured_media_id + '"]');
        if (slide && fromUser) {
          var main = slide.closest('.gallery__main');
          if (main) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
        }
      }
      if (isMain && fromUser) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(true); });

    update(false);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = e.submitter && e.submitter.hasAttribute('data-buy-now') ? e.submitter : form.querySelector('[data-add-button]');
      var buyNow = btn && btn.hasAttribute('data-buy-now');
      var qty = parseInt((root.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1;
      var props = {};
      $$('[name^="properties["]', form).forEach(function (p) { if (p.value) props[p.name.slice(11, -1)] = p.value; });
      btn.classList.add('is-loading');
      addToCart([{ id: parseInt(idInput.value, 10), quantity: qty, properties: props }], buyNow ? { redirect: '/checkout' } : {})
        .then(function () { var qv = document.getElementById('QuickView'); if (qv && qv.contains(root) && !buyNow) closeDrawer(qv); })
        .catch(function (err) { toast(err.message); })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }
  $$('[data-product-form]').forEach(initProductForm);

  // sticky add-to-cart on mobile
  (function () {
    var bar = $('[data-sticky-atc]'), main = $('[data-main-product] [data-add-button]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(main);
    bar.querySelector('[data-sticky-add]').addEventListener('click', function () { main.click(); });
  })();

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.gallery__main'); if (!main) return;
    var slides = $$('.gallery__slide', main), thumbs = $$('.gallery__thumb', g), dots = $$('.gallery__dots span', g);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: 'smooth' }); });
    });
    main.addEventListener('scroll', debounce(function () {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var count = g.querySelector('[data-gallery-count]'); if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }, 60));
  });

  /* ---------- collection & search filtering ---------- */
  function facetsRoot() { return $('[data-facets-root]'); }
  function renderFacets(url, push) {
    var root = facetsRoot(); if (!root) return;
    var results = $('[data-results]', root); if (results) results.classList.add('is-loading');
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', root.dataset.sectionId);
    return fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parseHTML(html);
      ['[data-results]', '[data-facets]', '[data-active-filters]', '[data-results-count]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        $$(sel, root).forEach(function (old) {
          if (!fresh) return;
          // don't wipe a price field while the shopper is still typing in it
          var a = document.activeElement;
          if (old.contains(a) && a.type === 'number') return;
          old.innerHTML = fresh.innerHTML;
        });
      });
      u.searchParams.delete('section_id');
      if (push) window.history.pushState({ facets: true }, '', u.pathname + (u.search || ''));
    }).finally(function () { var r2 = $('[data-results]', root); if (r2) r2.classList.remove('is-loading'); });
  }
  function urlFromForm(form) {
    var fd = new FormData(form), params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var q = new URLSearchParams(window.location.search);
    if (q.get('q') && !params.get('q')) params.set('q', q.get('q'));
    if (q.get('type') && !params.get('type')) params.set('type', q.get('type'));
    return window.location.pathname + '?' + params.toString();
  }
  var onFacetChange = debounce(function (form) { renderFacets(urlFromForm(form), true); }, 400);
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facet-form]'); if (!form) return;
    // keep the sidebar form and the drawer form in sync
    if (e.target.name) {
      $$('[data-facet-form]').forEach(function (other) {
        if (other === form) return;
        $$('[name="' + CSS.escape(e.target.name) + '"]', other).forEach(function (el) {
          if (el.type === 'checkbox') { if (el.value === e.target.value) el.checked = e.target.checked; }
          else el.value = e.target.value;
        });
      });
    }
    onFacetChange(form);
  });
  document.addEventListener('input', function (e) {
    var form = e.target.closest('[data-facet-form]');
    if (form && e.target.type === 'number') onFacetChange(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facet-form]'); if (!form) return;
    e.preventDefault(); renderFacets(urlFromForm(form), true);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-facet-link]'); if (!a) return;
    e.preventDefault(); renderFacets(a.href, true);
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.facets) renderFacets(window.location.href, false); });

  // load more
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]'); if (!btn) return;
    e.preventDefault();
    var root = facetsRoot(); if (!root) { window.location.href = btn.href; return; }
    btn.classList.add('is-loading');
    var u = new URL(btn.href, window.location.origin); u.searchParams.set('section_id', root.dataset.sectionId);
    fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parseHTML(html);
      var grid = $('[data-product-grid]', root);
      $$('[data-product-grid] > li', doc).forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
      var next = doc.querySelector('[data-load-more-wrap]');
      var wrap = $('[data-load-more-wrap]', root);
      if (wrap) wrap.innerHTML = next ? next.innerHTML : '';
      syncWishButtons();
    }).finally(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- predictive search ---------- */
  var searchModal = $('[data-search-modal]');
  function openSearch() {
    if (!searchModal) return;
    lastFocus = document.activeElement;
    searchModal.classList.add('is-open'); document.body.classList.add('is-locked');
    var input = searchModal.querySelector('input[type="search"]'); setTimeout(function () { input.focus(); }, 30);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]') || e.target === searchModal) closeSearch();
  });
  if (searchModal) {
    var input = searchModal.querySelector('input[type="search"]');
    var results = searchModal.querySelector('[data-predictive]');
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      fetch(R.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag,vendor&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html); var c = doc.querySelector('[data-predictive-content]');
          results.innerHTML = c ? c.innerHTML : '';
        });
    }, 250));
  }

  /* ---------- wishlist (stored in this browser) ---------- */
  function wishlist() { return store(WISH_KEY) || []; }
  function syncWishButtons() {
    var list = wishlist();
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.dataset.wish) > -1 ? 'true' : 'false'); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = !list.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var list = wishlist(), h = b.dataset.wish, i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); } else { list.unshift(h); toast('Saved to wishlist'); }
    store(WISH_KEY, list.slice(0, 60)); syncWishButtons();
    var page = $('[data-wishlist-page]'); if (page && i > -1) { var li = b.closest('li'); if (li) li.remove(); }
  });
  syncWishButtons();

  function loadCards(handles, grid, emptyEl) {
    if (!handles.length) { if (emptyEl) emptyEl.hidden = false; return; }
    Promise.all(handles.map(function (h) {
      return fetch(R.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=card-fragment')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var count = 0;
      htmls.forEach(function (html) {
        if (!html) return;
        var li = parseHTML(html).querySelector('[data-card-fragment] > li');
        if (li) { grid.appendChild(document.importNode(li, true)); count++; }
      });
      if (!count && emptyEl) emptyEl.hidden = false;
      syncWishButtons();
    });
  }
  $$('[data-wishlist-page]').forEach(function (el) {
    loadCards(wishlist(), el.querySelector('[data-product-grid]'), el.querySelector('[data-empty]'));
  });

  /* ---------- recently viewed ---------- */
  var current = $('[data-main-product]');
  if (current && current.dataset.handle) {
    var recent = (store(RECENT_KEY) || []).filter(function (h) { return h !== current.dataset.handle; });
    $$('[data-recently-viewed]').forEach(function (el) {
      var limit = parseInt(el.dataset.limit || '4', 10);
      var grid = el.querySelector('[data-product-grid]');
      if (recent.length) { el.hidden = false; loadCards(recent.slice(0, limit), grid); }
    });
    recent.unshift(current.dataset.handle);
    store(RECENT_KEY, recent.slice(0, 12));
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = parseHTML(html); var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('li')) { el.innerHTML = fresh.innerHTML; el.hidden = false; syncWishButtons(); }
    });
  });

  /* ---------- bundle builder ---------- */
  $$('[data-bundle]').forEach(function (b) {
    function total() {
      var sum = 0, n = 0;
      $$('input[type="checkbox"]', b).forEach(function (c) { if (c.checked) { sum += parseInt(c.dataset.price, 10); n++; } });
      $('[data-bundle-total]', b).textContent = formatMoney(sum);
      var btn = $('[data-bundle-add]', b); btn.disabled = !n;
    }
    b.addEventListener('change', total); total();
    $('[data-bundle-add]', b).addEventListener('click', function () {
      var items = $$('input[type="checkbox"]:checked', b).map(function (c) { return { id: parseInt(c.value, 10), quantity: 1 }; });
      var btn = this; btn.classList.add('is-loading');
      addToCart(items).catch(function (err) { toast(err.message); }).finally(function () { btn.classList.remove('is-loading'); });
    });
  });

  /* ---------- order tracking helper ---------- */
  $$('[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = form.querySelector('input').value.trim(); if (!v) return;
      window.open(form.dataset.pattern.replace('{id}', encodeURIComponent(v)), '_blank', 'noopener');
    });
  });

  /* ---------- tabs (product tabs, routine tabs) ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[role="tab"]', wrap), panels = $$('[role="tabpanel"]', wrap);
    function select(i, focus) {
      tabs.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); x.tabIndex = i === j ? 0 : -1; });
      panels.forEach(function (p, j) { p.hidden = i !== j; });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
      });
    });
  });

  /* ---------- carousels: arrow buttons scroll the track ---------- */
  $$('[data-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-carousel-track]'); if (!track) return;
    var prev = c.querySelector('[data-carousel-prev]'), next = c.querySelector('[data-carousel-next]');
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', debounce(sync, 80)); sync();
  });

  /* ---------- image zoom: hover magnify on desktop, full-screen view on tap ---------- */
  var zoomBox = $('[data-zoom-dialog]');
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom-src]'); if (!z || !zoomBox) return;
    e.preventDefault();
    var img = zoomBox.querySelector('img');
    img.src = z.dataset.zoomSrc; img.alt = z.dataset.zoomAlt || '';
    lastFocus = document.activeElement;
    zoomBox.hidden = false; document.body.classList.add('is-locked');
    zoomBox.querySelector('button').focus();
  });
  function closeZoom() { if (!zoomBox || zoomBox.hidden) return; zoomBox.hidden = true; document.body.classList.remove('is-locked'); if (lastFocus) lastFocus.focus(); }
  if (zoomBox) {
    zoomBox.addEventListener('click', function (e) { if (e.target === zoomBox || e.target.closest('button')) closeZoom(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
  }
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-hover-zoom]').forEach(function (frame) {
      var img = frame.querySelector('img'); if (!img) return;
      frame.addEventListener('mousemove', function (e) {
        var r = frame.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.8)';
      });
      frame.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });
  }

  /* ---------- newsletter validation ---------- */
  $$('[data-newsletter]').forEach(function (form) {
    var input = form.querySelector('input[type="email"]'), msg = form.querySelector('[data-newsletter-msg]');
    form.addEventListener('submit', function (e) {
      var v = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        e.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        if (msg) { msg.textContent = form.dataset.invalid || 'Enter an email like name@example.com'; msg.hidden = false; }
        input.focus();
      } else {
        input.removeAttribute('aria-invalid');
        var btn = form.querySelector('button[type="submit"]'); if (btn) btn.classList.add('is-loading');
      }
    });
    input.addEventListener('input', function () { input.removeAttribute('aria-invalid'); if (msg) msg.hidden = true; });
  });

  /* ---------- subtle reveal on scroll (skipped when reduced motion is on) ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('can-reveal');
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { ro.observe(el); });
  }

  /* ---------- offer box: copy the discount code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy-code]'); if (!b) return;
    var code = b.dataset.copyCode;
    var done = function () { toast('Code ' + code + ' copied. Paste it at checkout.'); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, function () { toast('Your code: ' + code); });
    else toast('Your code: ' + code);
  });
  /* ---------- sale countdown: counts down to one fixed moment for everyone ---------- */
  $$('[data-countdown-wrap]').forEach(function (wrap) {
    var end = parseInt(wrap.getAttribute('data-ends'), 10); if (!end) return;
    var d = $('[data-d]', wrap), h = $('[data-h]', wrap), m = $('[data-m]', wrap);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - nowSec();
      if (left <= 0) { wrap.remove(); clearInterval(timer); return; }
      d.textContent = pad(Math.floor(left / 86400));
      h.textContent = pad(Math.floor(left % 86400 / 3600));
      m.textContent = pad(Math.floor(left % 3600 / 60));
    }
    var timer = setInterval(tick, 15000); tick();
  });

  /* ---------- desktop mega menu: open on hover, close on leave ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-mega]').forEach(function (d) {
      var t;
      d.parentElement.addEventListener('mouseenter', function () { clearTimeout(t); $$('[data-mega][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); }); d.setAttribute('open', ''); });
      d.parentElement.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); }, 160); });
    });
  }
})();
